var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5885_16453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 13,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0095 9.66081C11.7044 9.97438 11.2097 9.97438 10.9047 9.66081L6.24893 4.87558L1.59321 9.66081C1.28812 9.97438 0.793484 9.97438 0.488398 9.66081C0.183313 9.34724 0.183313 8.83884 0.488398 8.52527L6.24893 2.60449L12.0095 8.52527C12.3146 8.83884 12.3146 9.34724 12.0095 9.66081Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5885_16453)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000976562,
    width: 12.4995,
    height: 12.4997,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.31e859870c4864483b84777398d53d4b.svg";
export { ForwardRef as ReactComponent };